import React from 'react';
import { styled } from 'linaria/react';
import isEmpty from 'lodash/isEmpty';
import { use100vh } from 'react-div-100vh';
import { SnackbarProvider, Loader } from 'fronton-react';
import { DataContext, RouteContext, TData } from 'entries/common/widgets/context';
import { Content } from './content';
import { Fallback } from '../fallback/fallback';
import { useGetParametersCalculatorData } from './hooks/use-get-parameters-calcualtor-data';

export const MainPage = ({ data }: { data: TData }) => {
  const height = use100vh();
  const calculatedHeight = height ? height - 48 : 'calc(100vh - 48px)';

  const { isError, calculatorParams, route, setRoute } = useGetParametersCalculatorData({ data });

  if (isError) {
    return <Fallback />;
  }

  if (isEmpty(calculatorParams)) {
    return (
      <LoadingContainer>
        <Loader />
      </LoadingContainer>
    );
  }

  return (
    <DataContext.Provider value={calculatorParams as TData}>
      <SnackbarProvider>
        <RouteContext.Provider value={{ context: route, setContext: setRoute }}>
          <Layout height={calculatedHeight}>
            <Container>
              <Content />
            </Container>
          </Layout>
        </RouteContext.Provider>
      </SnackbarProvider>
    </DataContext.Provider>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
`;

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100vh - 112px);

  @media (--only-mobile) {
    height: calc(100vh - 48px);
  }
`;

const Layout = styled.div<{ height: number | string }>`
  width: 100%;
  height: ${props => props.height}px;
`;
